module.exports = __webpack_public_path__ + "img/Instruction Learning Hotspot Box.e363a8ae.png";